import { View, Flex, Spacer } from "@base-ui";
import { ControlPanel } from "@interdependence-ui";
import { ErrorBanner } from "@notifications/errorNotifications";
import { useNotificationContext } from "@notifications/context";
import { DialogAligner } from "../dialogAligner/DialogAligner";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var CmsPage = function CmsPage(_ref) {
  var id = _ref.id,
    title = _ref.title,
    controlpanel = _ref.controlpanel,
    view = _ref.view,
    _ref$panelWidth = _ref.panelWidth,
    panelWidth = _ref$panelWidth === void 0 ? "280px" : _ref$panelWidth;
  var _useNotificationConte = useNotificationContext(),
    notification = _useNotificationConte.notification,
    showNotification = _useNotificationConte.showNotification;
  var height = showNotification && notification !== null && notification !== void 0 && notification.text ? "calc(100vh - 104px)" : "";
  return /*#__PURE__*/_jsxs(View, {
    maxHeight: true,
    height: height,
    children: [/*#__PURE__*/_jsx(ControlPanel, {
      id: id,
      title: title,
      width: panelWidth,
      children: controlpanel
    }), /*#__PURE__*/_jsxs(Spacer, {
      p: "sm",
      controlPanelPage: true,
      position: "relative",
      id: "main-scroll-el",
      overflowX: "hidden",
      children: [/*#__PURE__*/_jsx(ErrorBanner, {
        m: "-20px -20px 0px",
        top: "-20px",
        width: "calc(100% + 40px)"
      }), /*#__PURE__*/_jsx(Flex.Column, {
        as: "main",
        mb: "20px",
        children: view
      })]
    }), /*#__PURE__*/_jsx(DialogAligner, {})]
  });
};